(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initReveal = (root) => {
    const items = [...root.querySelectorAll('[data-elo-page-reveal]')];
    root.classList.add('is-ready');

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );

    items.forEach((item) => observer.observe(item));
  };

  const initRail = (rail) => {
    const track = rail.querySelector('[data-elo-rail-track]');
    const slides = [...track?.children || []];
    const previous = rail.querySelector('[data-elo-rail-prev]');
    const next = rail.querySelector('[data-elo-rail-next]');
    const status = rail.querySelector('[data-elo-rail-status]');
    if (!track || slides.length < 2) return;

    const getIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return slides.reduce(
        (closest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: 0, distance: Number.POSITIVE_INFINITY },
      ).index;
    };

    const update = () => {
      const index = getIndex();
      if (status) status.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    const goTo = (index) => {
      slides[Math.max(0, Math.min(slides.length - 1, index))]?.scrollIntoView({
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    };

    previous?.addEventListener('click', () => goTo(getIndex() - 1));
    next?.addEventListener('click', () => goTo(getIndex() + 1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initPage = (root) => {
    if (root.dataset.eloPageInitialized === 'true') return;
    root.dataset.eloPageInitialized = 'true';
    initReveal(root);
    root.querySelectorAll('[data-elo-rail]').forEach(initRail);
    root.querySelector('.elo-contact__success, .elo-contact__errors')?.focus({ preventScroll: true });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-elo-page]').forEach(initPage);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
